$(document).ready(function () {
  $(document).on("click", ".trigger_popup_fricc1", function () {
    console.log("click");
    $(".hover_bkgr_fricc1").show();
  });

  $(document).on("click", ".hover_bkgr_fricc1", function () {
    $(".hover_bkgr_fricc1").hide();
  });

  $(document).on("click", ".popupCloseButton1", function () {
    $(".hover_bkgr_fricc1").hide();
  });

  var custom_ship = $(".custom-ship-text").attr("data-ship");
  console.log("custom_ship---------------------", custom_ship);
  setTimeout(function () {
    if (
      $("buy-buttons .button").text().trim().toLowerCase() === "add to cart"
    ) {
      $(".custom-ship-text").text(custom_ship);
    }
  }, 2000);
  
  // Function to auto-select first available size
  function autoSelectFirstAvailableSize() {
    
    // Find size fieldset
    const $sizeFieldset = $('.variant-picker__option').filter(function() {
      const legend = $(this).find('legend').text().toLowerCase();
      return legend.includes('size');
    });
    
    if ($sizeFieldset.length === 0) {
      console.log('Size fieldset not found');
      return;
    }
    
    // Find all size inputs
    const $sizeInputs = $sizeFieldset.find('input[data-option-position]');
    console.log('Found size inputs:', $sizeInputs.length);
    
    // Find first available size (not disabled)
    let $firstAvailableInput = null;
    
    $sizeInputs.each(function() {
      const $input = $(this);
      const $label = $('label[for="' + $input.attr('id') + '"]');
      
      if ($label.length > 0) {
        const labelClasses = $label.attr('class') || '';
        const isDisabled = labelClasses.includes('is-disabled');
        
        console.log('Size:', $label.text().trim(), 'Disabled:', isDisabled);
        
        if (!isDisabled && !$firstAvailableInput) {
          $firstAvailableInput = $input;
        }
      }
    });
    
    if ($firstAvailableInput && $firstAvailableInput.length > 0) {
      const $label = $('label[for="' + $firstAvailableInput.attr('id') + '"]');
      const sizeText = $label.text().trim();
      
      // Check if already selected
      if ($firstAvailableInput.is(':checked')) {
        console.log('Size already selected, skipping');
        return;
      }
      
      // Click the label to trigger Shopify's native selection
      $label.click();
      
      
      // Add debug class
    
    } else {
      console.log('No available sizes found');
    }
  }
  
  // Run on page load
  setTimeout(autoSelectFirstAvailableSize, 500);
  
  // Listen for color changes
  $(document).on('change', 'input[data-option-position]', function() {
    const $fieldset = $(this).closest('.variant-picker__option');
    const legend = $fieldset.find('legend').text().toLowerCase();
    
    // Only trigger on color changes
    if (legend.includes('color') || legend.includes('colour')) {
      setTimeout(autoSelectFirstAvailableSize, 300);
    }
  });
});

